export { default as HomeInfo } from './Home'
